
import { useState, useEffect } from 'react'
import HomeHeroSection from '../../sections/HomeHeroSection/HomeHeroSection'
import AchievementsContainer from '../../components/AchievementsContainer/AchievementsContainer'
import ServicesSection from '../../sections/ServicesSection/ServicesSection'
import AdditionalService from '../../sections/AdditionalService/AdditionalService'
import HighlightSection from '../../sections/HighlightSection/HighlightSection'
import TestimonialsSection from '../../sections/TestimonialsSection/TestimonialsSection'
import FlyersSection from '../../sections/FlyersSection/FlyersSection'
import Reservations from '../../components/Reservations/Reservations'
import InstaGrid from '../../sections/InstaGrid/InstaGrid'
import FeaturedEvent from '../../components/FeaturedEvent/FeaturedEvent'

// Firebase Imports
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const HomePage = () => {
    const [featuredEvent, setFeaturedEvent] = useState(null);

    // Fetch Featured Event Logic
    useEffect(() => {
        const fetchFeaturedEvent = async () => {
            try {
                const todayString = new Date().toISOString().split("T")[0];
                const q = query(
                    collection(db, "events"),
                    where("featured", "==", true),
                    where("status", "==", "published")
                );

                const snapshot = await getDocs(q);
                const upcomingFeatured = snapshot.docs
                    .map((doc) => ({ id: doc.id, ...doc.data() }))
                    .filter((event) => event.date >= todayString)
                    .sort((a, b) => a.date.localeCompare(b.date));

                if (upcomingFeatured.length > 0) {
                    setFeaturedEvent(upcomingFeatured[0]);
                }
            } catch (error) {
                console.error("Error fetching featured event:", error);
            }
        };
        fetchFeaturedEvent();
    }, []);

    // Helper function for the component
    const formatDate = (dateStr, timeStr) => {
        if (!dateStr) return "";
        const dateObj = new Date(dateStr);
        const formattedDate = dateObj.toLocaleDateString("en-GB", {
            weekday: "short", day: "2-digit", month: "short",
        });

        let formattedTime = "";
        if (timeStr) {
            const [hours, minutes] = timeStr.split(":");
            const temp = new Date();
            temp.setHours(hours); temp.setMinutes(minutes);
            formattedTime = temp.toLocaleTimeString("en-US", {
                hour: "2-digit", minute: "2-digit", hour12: true,
            });
        }
        return `${formattedDate} · ${formattedTime}`;
    };

    return (
        <div>
            <HomeHeroSection />
            <AchievementsContainer />
            <FlyersSection />
            <ServicesSection />

            {/* Pass data to the reusable component */}
            {featuredEvent && (
                <FeaturedEvent isHome = {true} event={featuredEvent} formatDate={formatDate} />
            )}

            <AdditionalService />
            <HighlightSection />
            <InstaGrid />
            <TestimonialsSection />
            <Reservations />
        </div>
    )
}

export default HomePage